import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';

const RankRepository = RepositoryFactory.get('rank') as Repositories['rank'];

export const useRank = () => {
  /**
   * ランク情報
   */
  const get = async (rankId: string) => {
    return await RankRepository.get(rankId);
  };

  /**
   * ランク情報を顧客属性から探索
   */
  const findRank = async (customerAttributes: any /** CustomerAttributes */[]) => {
    const attr = customerAttributes.find(v => v.key === 'rank');
    if (!attr) return null;
    return attr;
  };

  return {
    get,
    findRank,
  };
};

type RankType = ReturnType<typeof useRank>;
export const RankKey: InjectionKey<RankType> = Symbol('Rank');
